import React, { Component } from 'react';
import ContMessageI18N from '../../containers/ContMessageI18N';

class CalculatorButton extends Component {
	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
    render() {
        return (
            <span data-bs-toggle="modal" data-bs-target="#modalCalculator">
                <button className='btn btn-outline-primary' onClick={() => { this.props.onCalcOpen(); }}>
                    {this.getMessage('testpage.cta.testCalculator')}
                </button>
            </span>
        )
    }
}

export default (CalculatorButton)
